const buttonUX = {
  backgroundColor: 'hsla(0, 0%, 0%, 4%)',
  borderRadius: '5px',
  '&:hover': {
    backgroundColor: 'hsla(0, 0%, 0%, 10%)',
  },
  '&:active': {
    backgroundColor: 'hsla(0, 0%, 0%, 20%)',
  },
}

export default {
  wrapper: {
    position: 'absolute',
    backgroundColor: 'white',
    borderRadius: '5px',
    padding: '12px',
    zIndex: '100',
    bottom: '23px',
    display: 'flex',
    flexDirection: 'column',
    width: '300px',
    overflow: 'hidden',
  },
  section: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    '& + *': {
      marginTop: '12px',
    },
  },
  flexWrapper: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    padding: '12px',
    width: '100%',
    '& + *': {
      marginLeft: '12px',
    },
    ...buttonUX,
  },
  colorSelectWrapper: {
    flex: 1,
    '&:not(:last-child)': {
      marginRight: 16,
    },
  },
  buttonIcon: {
    display: 'flex',
    padding: '16px',
    cursor: 'pointer',
    marginBottom: '2px',
    ...buttonUX,
  },
  blackMediumText: {
    fontSize: '14px',
    color: '#000',
    marginLeft: '12px',
  },
  invisibleInput: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    opacity: 0,
    cursor: 'pointer',
  },
  flex: {
    display: 'flex',
  },
  hint: {
    fontSize: '10px',
    opacity: '0.8',
    color: 'red',
    marginTop: '8px',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    '& > .ShapeSettingsModalView__button': {
      width: '100%',
    },
    '& > .ShapeSettingsModalView__button_cancel > input': {
      backgroundColor: 'hsla(0, 0%, 0%, 0.35)',
    },
  },
  loadingIndicatorWrapper: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'hsla(0, 0%, 0%, 20%)',
    left: 0,
    top: 0,
    zIndex: '9',
    cursor: 'wait',
  },
  simpleText: {
    marginTop: '10px',
    display: 'flex',
    fontSize: '12px',
  },
}
